import type { LandingComponent } from "./landing.component";
import type { HttpService } from "../services/http.service";
import type { StateService } from "../services/state.service";

type LandingAccessContext = Pick<
  LandingComponent,
  | "requestSubmitting"
  | "requestSubmitError"
  | "requestSubmitSuccess"
  | "showRequestAccessDialog"
>;

export class LandingAccessWorkflow {
  requestAccess(context: LandingAccessContext): void {
    context.requestSubmitting = false;
    context.requestSubmitError = null;
    context.requestSubmitSuccess = false;
    context.showRequestAccessDialog = true;
  }

  onRequestAccessSubmit(
    context: LandingAccessContext,
    httpService: HttpService,
    stateService: StateService,
    payload: Parameters<LandingComponent["onRequestAccessSubmit"]>[0],
  ): void {
    context.requestSubmitting = true;
    context.requestSubmitError = null;
    context.requestSubmitSuccess = false;

    const url = stateService.apiList.admin.onboardUser;
    httpService.postMethod(url, payload).subscribe({
      next: () => {
        context.requestSubmitting = false;
        context.requestSubmitSuccess = true;
        setTimeout(() => {
          context.requestSubmitSuccess = false;
        }, 100);
      },
      error: (err: any) => {
        context.requestSubmitting = false;
        context.requestSubmitError =
          err?.error?.message ??
          err?.message ??
          "Failed to send request. Please try again.";
      },
    });
  }
}
